import {
  AccordionDetails as AccordionDetailsCore,
  AccordionSummary as AccordionSummaryCore,
  Avatar as AvatarCore,
  Accordion as AccordionCore,
  Typography as TypographyCore,
} from '@material-ui/core';
import * as lib from '~/dependencies';

const { keyframes, css } = lib.StyledComponents;

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 12px rgba(0, 0, 0, 0);
  }
`;

export const Avatar = lib.styled(AvatarCore)`
  margin-top: 3px;
  margin-right: 1px;
  width: 22px !important;
  height: 22px !important;
  z-index: 1000;

  ${({ animate }: any) =>
    animate &&
    css`
      animation: ${pulseAnimation} 2s infinite;
    `}
`;

export const Accordion = lib.styled(AccordionCore)`
  box-shadow: none;
  box-shadow: unset !important;
`;

export const AccordionSummary = lib.styled(AccordionSummaryCore)`
  height: 41px!important;
  min-height: 41px!important;
  padding: 0 6px!important;
`;

export const AccordionDetails = lib.styled(AccordionDetailsCore)`
  width: 100%!important;
  flex-direction: column!important;
  padding: 0px 0px 3px 0px!important;
`;

export const Typography = lib.styled(TypographyCore)`
  font-size: 16px;
  font-weight: 600;
  color: #989898;
`;

export const AccordionBase = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
